<template lang="html">
  <root class="admin-update-password">

    <admin-nav></admin-nav>
    <page-header name="Update password" :count="false"></page-header>

    <!-- Form -->
    <div class="container">
      <div class="row">
        <div class="col m4 offset-m4">
          <div class="mui-textfield">
            <label>New password</label>
            <input type="password" class="password" v-model="password">
          </div>
          <!-- Switch -->
          <div class="switch">
            <label>
              Show password
              <input type="checkbox" class="check">
              <span class="lever"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col m4 offset-m4">
          <a class="waves-effect waves-light btn" @click="update" :disabled="isSending">Update</a>
        </div>
      </div>
    </div>

  </root>
</template>

<script>
import $ from 'jquery'
import * as firebase from 'firebase'

export default {
  data() {
    return {
      password: '',
      isSending: false,
    }
  },

  methods: {
    changepasswordtoggle() {
      $(".check").change(function() {
        let type = (this.checked) ? 'text' : 'password'
        $('.password').attr('type', type)
      })
    },

    update() {

      // Field is requried
      if(!this.password) {
        Materialize.toast('All fields are required', 4000)
        return
      }

      this.isSending = true

      // Update
      firebase.database()
        .ref('config/admin')
        .update({ password: btoa(this.password) })
        .then( () => {
          Materialize.toast('Updated', 4000)
          this.isSending = false
          this.password = ''
        })

    }
  },

  // Mounted
  mounted() {
    this.changepasswordtoggle()
  }
}
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Admin/PasswordUpdate.vue